import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import {
  GuestContinuationStatus,
  GuestUpgradeClaimService,
  GuestUpgradeType
} from "./guest-upgrade-claim.service";

export interface GuestContinuationObservation {
  status?: GuestContinuationStatus;
  error?: any;
}

@Injectable({ providedIn: "root" })
export class GuestContinuationObserverService {
  constructor(private guestUpgradeClaimService: GuestUpgradeClaimService) {}

  public observe(type: GuestUpgradeType, eventId: string): Observable<GuestContinuationObservation> {
    return new Observable((observer) => {
      let request: Subscription;
      let stopped = false;
      let requestActive = false;

      const check = () => {
        if (stopped || requestActive) {
          return;
        }
        requestActive = true;
        request = this.guestUpgradeClaimService.continuationStatus(type, eventId).subscribe({
          next: (status) => {
            requestActive = false;
            if (!status) {
              return;
            }
            if (status.status === "REVOKED") {
              this.guestUpgradeClaimService.clearAllTransitionState();
            }
            observer.next({ status });
            if (status.status === "CLAIMED" || status.status === "REVOKED"
                || status.status === "EXPIRED") {
              stopped = true;
              observer.complete();
            }
          },
          error: (error) => {
            requestActive = false;
            observer.next({ error });
          }
        });
      };
      const onVisible = () => {
        if (typeof document === "undefined" || document.visibilityState !== "hidden") {
          check();
        }
      };
      const timer = window.setInterval(check, 3000);
      window.addEventListener("focus", check);
      window.addEventListener("pageshow", check);
      document.addEventListener("visibilitychange", onVisible);
      check();

      return () => {
        stopped = true;
        window.clearInterval(timer);
        window.removeEventListener("focus", check);
        window.removeEventListener("pageshow", check);
        document.removeEventListener("visibilitychange", onVisible);
        if (request) {
          request.unsubscribe();
        }
      };
    });
  }
}
